import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header({ user, onLogout }) {
  const handleSteamLogin = () => {
    window.location.href = 'https://optimizerust.ru/api/auth/steam';
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <span className="logo-text">OptimizeRust</span>
          </Link>
          <nav className="nav">
            <Link to="/" className="nav-link">Главная</Link>
            <Link to="/pricing" className="nav-link">Цены</Link>
            <Link to="/reviews" className="nav-link">Отзывы</Link>
            {user?.isAdmin && (
              <>
                <Link to="/admin" className="nav-link">Модерация</Link>
                <Link to="/users" className="nav-link">Пользователи</Link>
              </>
            )}
          </nav>
          <div className="header-auth">
            {user ? (
              <div className="user-info">
                <img 
                  src={user.avatar || '/default-avatar.png'} 
                  alt={user.username}
                  className="user-avatar"
                />
                <span className="user-name">{user.username}</span>
                <button onClick={onLogout} className="btn-logout">Выход</button>
              </div>
            ) : (
              <button onClick={handleSteamLogin} className="btn-steam">
                Войти через Steam
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;

